import { ExternalLink } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLanguage } from "../i18n/LanguageContext";

const Corners = () => (
    <>
        <span aria-hidden="true" className="absolute -top-2 -left-2 w-8 h-8 border-t border-l border-[#c9a24b]" />
        <span aria-hidden="true" className="absolute -top-2 -right-2 w-8 h-8 border-t border-r border-[#c9a24b]" />
        <span aria-hidden="true" className="absolute -bottom-2 -left-2 w-8 h-8 border-b border-l border-[#c9a24b]" />
        <span aria-hidden="true" className="absolute -bottom-2 -right-2 w-8 h-8 border-b border-r border-[#c9a24b]" />
    </>
);

export const ConvidadoHonra = () => {
    const { t } = useLanguage();
    const c = t.convidadoHonra;
    return (
        <section id="convidado-honra" className="relative py-14 sm:py-20 scroll-mt-24" data-testid="convidado-honra-section">
            <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_40%,rgba(120,20,30,0.22),transparent_60%)] pointer-events-none" />
            <div className="relative mx-auto max-w-[1300px] px-5 sm:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
                <Reveal className="lg:col-span-5 flex justify-center lg:justify-end">
                    <div className="relative w-full max-w-sm">
                        <div className="relative border border-[#c9a24b]/60 p-2 bg-[#0a0705]">
                            <Corners />
                            <img loading="lazy" decoding="async" src="/images/convidado-honra-consul.webp" alt={`${c.nome} — ${c.cargo}`}
                                className="w-full h-auto object-cover" data-testid="convidado-honra-foto" />
                        </div>
                        <p className="mt-4 font-display italic text-lg sm:text-xl text-center text-[#ecd49b]" data-testid="convidado-honra-bemvindo">{c.bemVindo}</p>
                    </div>
                </Reveal>

                <Reveal delay={0.1} className="lg:col-span-7">
                    <p className="font-caps text-[10px] sm:text-[11px] tracking-[0.35em] uppercase text-[#c9a24b]" data-testid="convidado-honra-label">
                        {c.label} <span className="text-[#c9a24b]/50">·</span> <span className="text-[#efe6d6]/60">{c.confirmado}</span>
                    </p>
                    <p className="mt-6 font-display font-light text-base sm:text-lg text-[#efe6d6]/60">{c.excelencia}</p>
                    <h2 className="font-display font-medium text-4xl sm:text-5xl lg:text-6xl text-[#efe6d6] leading-[1.05] mt-1" data-testid="convidado-honra-nome">{c.nome}</h2>
                    <p className="mt-3 font-caps text-xs sm:text-sm tracking-[0.22em] uppercase gold-text" data-testid="convidado-honra-cargo">{c.cargo}</p>

                    <blockquote className="mt-8 border-l border-[#c9a24b]/60 pl-5" data-testid="convidado-honra-citacao">
                        <p className="font-display italic font-light text-xl sm:text-2xl text-[#efe6d6]/90 leading-snug">“{c.citacao}”</p>
                    </blockquote>

                    <p className="mt-8 font-light text-sm sm:text-base text-[#efe6d6]/70 leading-relaxed max-w-2xl" data-testid="convidado-honra-texto">{c.texto}</p>

                    <div className="mt-8 border-t border-[#c9a24b]/15 pt-6 max-w-2xl">
                        <p className="font-caps text-[10px] tracking-[0.3em] uppercase text-[#c9a24b]/70">{c.sobreTitulo}</p>
                        <p className="mt-3 font-light text-sm text-[#efe6d6]/55 leading-relaxed" data-testid="convidado-honra-sobre">{c.sobre}</p>
                    </div>

                    <a href="/images/convidado-honra-poster.webp" target="_blank" rel="noopener noreferrer" data-testid="convidado-honra-cartaz"
                        className="group mt-8 inline-flex items-center gap-2 border border-[#c9a24b]/60 px-5 py-2.5 font-caps text-[10px] tracking-[0.22em] uppercase text-[#c9a24b] hover:border-[#c9a24b] hover:bg-[#c9a24b]/5 transition-colors duration-400">
                        {c.verCartaz}
                        <ExternalLink size={13} className="group-hover:translate-x-0.5 transition-transform duration-300" />
                    </a>
                </Reveal>
            </div>
        </section>
    );
};
